import {
  Box,
  // Button,
  Divider,
  Grid,
  StyleRules,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { Component } from "react";
import aboutGif from "../assets/about.gif";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
interface Props {
  classes: any;
}
class About extends Component<Props> {
  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.aboutSectionBody}>
        <Grid
          item
          xl={6}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          className={classes.aboutGif}
        >
          <img src={aboutGif} className={classes.aboutGifImage} alt="GIF" />
        </Grid>
        <Grid
          item
          xl={6}
          lg={6}
          md={12}
          sm={12}
          xs={12}
          className={classes.aboutText}
        >
          <Box className={classes.aboutTitle}>
            <Typography
              className={classes.aboutCodezzy}
              style={{ fontWeight: "700" }}
            >
              About&nbsp;
            </Typography>
            <Typography
              className={classes.codezzy}
              style={{ fontWeight: "700" }}
            >
              Codezzy
            </Typography>
          </Box>
          <Divider className={classes.aboutDivision} />
          <Typography
            className={classes.aboutDescription}
            style={{ fontWeight: "400", textAlign: "justify" }}
          >
            {/* Codezzy is an interactive learning platform offering high-quality
            coding courses in various programming languages on numerous tech
            subjects like web app development (<b>React JS and React Native</b>)
            In addition, it provides a programming practice platform for
            beginners. */}
            Welcome to Codezzy, where your tech aspirations come to life!
            Immerse yourself in our comprehensive array of industry-leading
            courses, meticulously crafted to propel you to the forefront of IT
            excellence. From mastering coding essentials to advanced
            programming, Codezzy is your gateway to skill enhancement and
            professional growth. Our dynamic curriculum ensures you stay ahead
            in the ever-evolving tech landscape. Join us on this transformative
            journey, unlocking your full potential and shaping a successful
            future in the world of technology. Elevate your skills with Codezzy
            - Where Innovation Meets Expertise.
          </Typography>
          <Box>
            <Typography
              className={classes.points}
              style={{ fontWeight: "400" }}
            >
              <ArrowForwardIcon className={classes.arrow} />
              &nbsp;&nbsp;1:1 Mentorship
            </Typography>
            <Typography
              className={classes.points}
              style={{ fontWeight: "400" }}
            >
              <ArrowForwardIcon className={classes.arrow} />
              &nbsp;&nbsp;Best Study Material
            </Typography>
            <Typography
              className={classes.points}
              style={{ fontWeight: "400" }}
            >
              <ArrowForwardIcon className={classes.arrow} />
              &nbsp;&nbsp;Professional Content
            </Typography>
          </Box>
          {/* <Button
            variant="contained"
            className={classes.demoBtn}
            style={{ fontWeight: "700" }}
          >
            Get Free Demo
          </Button> */}
        </Grid>
      </Grid>
    );
  }
}
const aboutstyle: StyleRules = {
  aboutSectionBody: {
    background:
      "linear-gradient(270deg, #FFFBF5 0%, #FFFBF5 95.12%) !important",
    display: "flex  !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    // padding: "5em !important",
    padding: "20px !important",
  },
  arrow: {
    borderRadius: "50% !important",
    border: "1px solid rgba(8, 79, 192, 1) !important",
    color: "rgba(8, 79, 192, 1)  !important",
    marginRight: "7px !important",
  },
  points: {
    fontWeight: 400,
    fontSize: "16px !important",
    lineHeight: "18.75px !important",
    display: "flex !important",
    alignItems: "center !important",
    margin: "10px 0 10px 7px !important",
  },
  aboutGif: {
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
  },
  aboutText: {
    display: "flex !important",
    flexDirection: "column",
    // alignItems: "center !important",
    justifyContent: "center !important",
    paddingLeft: "80px !important",
    paddingRight: "80px !important",
  },
  aboutDescription: {
    fontSize: "17px !important",
    lineHeight: "26px !important",
    fontWeight: 400,
    margin: "10px 0 10px 0  !important",
    maxWidth: "810px   !important",
  },
  aboutTitle: {
    display: "flex !important",
    marginBottom: "10px !important",
    flexDirection: "row",
  },
  aboutCodezzy: {
    fontFamily: "Nunito   !important",
    fontWeight: 700,
    fontSize: "48px   !important",
    lineHeight: "65px   !important",
  },
  codezzy: {
    fontFamily: "Nunito   !important",
    fontWeight: 700,
    fontSize: "48px   !important",
    lineHeight: "65px   !important",
    color: "rgba(181, 87, 254, 1)   !important",
  },
  aboutGifImage: { maxWidth: "100% !important", height: "auto" },
  aboutDivision: {
    background: "rgba(242, 39, 126, 1)   !important",
    height: "3px   !important",
    width: "330px   !important",
    marginBottom: "20px   !important",
  },
  demoBtn: {
    fontSize: "20px   !important",
    fontWeight: 700,
    fontFamily: "Roboto   !important",
    lineHeight: "23.44px   !important",
    color: "white   !important",
    background:
      "linear-gradient(89.65deg, #074CBA 2.14%, rgba(13, 106, 252, 0.988235) 99.74%)   !important",
    borderRadius: "6px   !important",
    padding: "10px   !important",
    height: "62.28px   !important",
    width: "224.22px   !important",
    margin: "20px 0 10px 0   !important",
  },
  "@media screen and (min-width: 600px) and (max-width: 1279px)": {
    aboutText: {
      alignItems: "center !important",
      paddingLeft: "30px !important",
      paddingRight: "30px !important",
    },
    aboutDescription: {
      maxWidth: "700px !important",
    },
    aboutDivision: { maxWidth: "280px" },
  },
  "@media screen and (min-width: 0px) and (max-width: 599px)": {
    aboutSectionBody: {
      padding: "20px !important",
    },
    aboutGifImage: { maxWidth: "70%" },
    aboutCodezzy: {
      marginTop: "20px !important",
      fontSize: "35px !important",
    },
    codezzy: {
      marginTop: "20px !important",
      fontSize: "35px !important",
    },
    aboutDivision: { maxWidth: "230px" },
    aboutDescription: {
      maxWidth: "700px !important",
      lineHeight: "26px   !important",
      fontSize: "12px   !important",
    },
    points: {
      fontSize: "14px   !important",
      lineHeight: "16.41px   !important",
    },
    aboutText: {
      alignItems: "center !important",
      paddingLeft: "30px !important",
      paddingRight: "30px !important",
    },
  },
};
export default withStyles(aboutstyle)(About);

